import { Button, Center, Text } from '@chakra-ui/react';

import Modal from '../../../../components/Modal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const FrozenOrLockedCreditNotificationModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal
      title="Your credit is frozen or locked"
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
    >
      <Text textAlign="center" mb={4}>
        Already working on this? No problem — just let us know so we can keep things moving.
      </Text>
      <Center>
        <Button mx="auto" onClick={onClose}>
          I'M WORKING ON IT
        </Button>
      </Center>
    </Modal>
  );
};

export default FrozenOrLockedCreditNotificationModal;
